
<div class="row">
    <div class="col-sm-6">
      <h4>Kitchen Stock Balance</h4>
      <p>Kitchen Stock / Kitchen Stock Balance</p>
    </div>
    <div class="col-sm-6 mt-3">   
    </div>
  </div>
  
  <div class="card mt-3 card-boarder-radius"  [ngClass]="{'dark-bg' : isDark }">
    <div class="row m-3">
      <div class="col-md-6">
        <div class="form-group">
          <label for="search" class="col-form-label">Search</label>  
          <div class="input-group">
                <div class="input-group-text bg-transparent border border-right-0"><i class="fa fa-search" [ngClass]="{'dark-bg' : isDark }"></i></div>
            <input [(ngModel)]="searchKey" (keyup)="applyFilter()" autocomplete="off" [ngClass]="{'dark-bg' : isDark }" class="form-control py-2 border   border-right-0 " type="text" placeholder="Search">
              <button class="btn  border border-left-0" type="button">
                  <i *ngIf="searchKey" (click)="onSearchClear()" class="fa fa-close" [ngClass]="{'dark-bg' : isDark }"></i>
              </button>         
           </div>   
          </div>
        </div>
  
  
        <div class="col-md-4 offset-2 mt-4 text-center">
           
      </div>
  
    </div>
  </div>
  
  <div class="row mt-3">
    <div class="col-12">
    <div class="card card-boarder-radius" [ngClass]="{'dark-bg' : isDark ,'dark-border-color' : isDark }">                  
     <div class="card-body">
      <div class="col-12 table-responsive scrollable" id="offerListReport"  #offerListReport>
        <table class="table" [ngClass]="{'dark-bg' : isDark }">
          <thead>
          <tr>                                
            <th>Item</th>          
            <th>Unit</th>
            <th>Qty Bal</th>                  
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let item of filteredFinalList; let i = index">    
          
            <td>{{item.Name}}</td>
            <td>{{item.Unit }}</td>
            <td>{{item.QtyBal }}</td>
          </tr>                                              
          </tbody>
        </table>
      </div>
      <!-- /.col -->
     </div>
    </div>
    </div>
    </div>
  
    <div class="row no-print">
      <div class="col-12">   
        <!-- <button type="button" printSectionId="cusBalReport" [useExistingCss]="true" ngxPrint  class="btn btn-default float-right"><i class="fas fa-print"></i> Print</button>   -->
         <button [ngClass]="{'dark-bg' : isDark }" type="button" (click)="savePDF('print')"  class="btn btn-default float-right"><i class="fas fa-print"></i> Print</button>      
        <button [ngClass]="{'dark-bg' : isDark }" type="button" (click)="exportexcel()"  class="btn btn-default float-right"><i class="fa fa-file-excel-o" style="color:green"></i> Excel</button>      
         <button [ngClass]="{'dark-bg' : isDark }" type="button" (click)="savePDF('open')"  class="btn btn-default float-right"><i class="fa fa-file-pdf-o" style="color:red"></i> PDF</button>                                                                                                                                                              
      </div>
    </div>
  
  
  
  
  
  
  
  

